import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { CancellationReasonRetenoValue } from 'pages/account/components/SubscriptionsTab/modals/CancellationReasonModal/types';

import { InferValueTypes } from 'types/commonTypes';
import { IDiscountSubscription } from 'types/subscription';

import * as action from './actions';
import * as actionTypes from './actionTypes';

type ActionType = ReturnType<InferValueTypes<typeof action>>;

export interface SubscriptionsState {
    subscriptions: ISubscriptionWellfunnel[];
    cancellationCandidates: ISubscriptionWellfunnel[] | null;
    discountSubscription: IDiscountSubscription | null;
    cancelReason: CancellationReasonRetenoValue | null;
}

export const initialState = {
    subscriptions: [],
    cancellationCandidates: null,
    discountSubscription: null,
    cancelReason: null,
};

const subscriptionsReducer = (state: SubscriptionsState = initialState, action: ActionType) => {
    switch (action.type) {
        case actionTypes.RESET_SUBSCRIPTIONS:
            return { ...initialState };

        case actionTypes.FETCH_USER_SUBSCRIPTIONS_SUCCESS:
            return { ...state, subscriptions: action.payload };

        case actionTypes.SET_CANCELLATION_CANDIDATE:
            return { ...state, cancellationCandidates: action.payload };

        case actionTypes.FETCH_DISCOUNT_SUBSCRIPTION_SUCCESS:
            return { ...state, discountSubscription: action.payload };

        case actionTypes.SET_CANCEL_REASON:
            return { ...state, cancelReason: action.payload };

        default:
            return state;
    }
};

export default subscriptionsReducer;
